import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {}

export const StyledVolumeIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M6.13337 12.7999H11.0896C11.1603 12.7999 11.2281 12.7718 11.2781 12.7218L16.0781 7.92178C16.2461 7.75379 16.5334 7.87277 16.5334 8.11034V23.8894C16.5334 24.127 16.2461 24.246 16.0781 24.078L11.2781 19.278C11.2281 19.228 11.1603 19.1999 11.0896 19.1999H6.13337C5.98609 19.1999 5.8667 19.0805 5.8667 18.9332V13.0666C5.8667 12.9193 5.98609 12.7999 6.13337 12.7999Z'
                fill='none'
            />
            <path
                d='M21.0349 20.3026C21.3247 20.4905 21.7142 20.4089 21.8804 20.1061C22.5701 18.8498 22.9339 17.4368 22.9334 15.997C22.9329 14.5571 22.5681 13.1443 21.8776 11.8885C21.7112 11.5858 21.3216 11.5045 21.0319 11.6926V11.6926C20.7422 11.8808 20.6625 12.2671 20.8251 12.5718C21.3861 13.6232 21.682 14.7993 21.6824 15.9974C21.6829 17.1954 21.3877 18.3718 20.8275 19.4235C20.6651 19.7284 20.7451 20.1146 21.0349 20.3026V20.3026Z'
                stroke='none'
            />
            <path
                d='M24.5518 22.5834C24.8764 22.7939 25.312 22.7022 25.5044 22.3666C26.6142 20.431 27.2009 18.2349 27.2001 15.9956C27.1993 13.7562 26.6112 11.5605 25.5 9.62564C25.3074 9.29016 24.8717 9.19885 24.5473 9.40957V9.40957C24.2228 9.62029 24.1327 10.0532 24.3231 10.3899C25.2881 12.0967 25.7985 14.0275 25.7991 15.996C25.7998 17.9646 25.2907 19.8957 24.327 21.6031C24.1368 21.94 24.2272 22.3729 24.5518 22.5834V22.5834Z'
                stroke='none'
            />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    height: 32px;
    width: 32px;
    fill: ${p => p.fill || p.theme.bgColor};
    stroke: ${p => p.stroke || p.theme.bgColor};
`
